import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@primer/react'
import {useLayoutBaseRepository} from '../../../../stores/selectors'
import {shortOid} from './short-oid'

export function ForcePushedText({info}: {info: IssueEventInfo}) {
  const repository = useLayoutBaseRepository()
  const {ref, beforeCommitOid, afterCommitOid} = info
  if (!beforeCommitOid || !afterCommitOid) return <>force pushed</>
  const comparisonPath = `/${repository.ownerLogin}/${repository.name}/compare/${beforeCommitOid}..${afterCommitOid}`
  return (
    <>
      <Link inline href={comparisonPath} className="fgColor-default text-semibold">
        force-pushed
      </Link>{' '}
      {ref ? <strong>{ref}</strong> : <span>this branch</span>}
      <span> from </span>
      <strong>
        <code>{shortOid(beforeCommitOid)}</code>
      </strong>
      <span> to </span>
      <strong>
        <code>{shortOid(afterCommitOid)}</code>
      </strong>
    </>
  )
}
